import { render, staticRenderFns } from "./DepartmentCustomField.vue?vue&type=template&id=ad98c3de&"
import script from "./DepartmentCustomField.vue?vue&type=script&lang=js&"
export * from "./DepartmentCustomField.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentCustomField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad98c3de')) {
      api.createRecord('ad98c3de', component.options)
    } else {
      api.reload('ad98c3de', component.options)
    }
    module.hot.accept("./DepartmentCustomField.vue?vue&type=template&id=ad98c3de&", function () {
      api.rerender('ad98c3de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/DepartmentCustomField.vue"
export default component.exports